"use client";

import { motion } from "framer-motion";

interface RemoveBgScanningProps {
  imageUrl: string;
  filename: string;
}

export default function RemoveBgScanning({ imageUrl, filename }: RemoveBgScanningProps) {
  return (
    <div className="flex flex-col items-center justify-center space-y-8 py-12">
      <div className="relative">
        {/* Imagem sendo escaneada */}
        <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-white/5">
          <div className="relative aspect-square w-64">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={imageUrl}
              alt="Imagem sendo processada"
              className="absolute inset-0 h-full w-full object-contain"
              loading="eager"
            />
          </div>

          {/* Linha de escaneamento animada */}
          <motion.div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-brand-secondary/30 to-transparent"
            initial={{ x: "-100%" }}
            animate={{ x: "100%" }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "linear"
            }}
          />

          {/* Overlay com efeito de processamento */}
          <div className="absolute inset-0 bg-brand-secondary/10 animate-pulse" />
        </div>

        {/* Pontos de processamento */}
        <div className="absolute -bottom-2 left-1/2 flex -translate-x-1/2 space-x-1">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="h-2 w-2 rounded-full bg-brand-secondary"
              animate={{
                scale: [1, 1.2, 1],
                opacity: [0.5, 1, 0.5]
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                delay: i * 0.2
              }}
            />
          ))}
        </div>
      </div>

      <div className="text-center">
        <h3 className="text-xl font-semibold text-white">Processando imagem...</h3>
        <p className="mt-2 text-sm text-white/60">
          Analisando {filename} com IA avançada
        </p>
        <div className="mt-4 flex items-center justify-center space-x-2">
          <div className="h-1 w-32 overflow-hidden rounded-full bg-white/10">
            <motion.div
              className="h-full bg-brand-secondary"
              initial={{ x: "-100%" }}
              animate={{ x: "100%" }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}